/**
 * 教室ページのルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import Login from '../views/branch/Login.vue'
import QrLogin from '../views/branch/QrLogin.vue'
import StudyManagement from '../views/branch/StudyManagement.vue'
import StudyManagementCandidate from '../views/branch/StudyManagementCandidate.vue'
import StudentManagement from '../views/branch/StudentManagement.vue'
import StudyResultManagement from '../views/branch/history/StudyResultManagement.vue'
import StudyResultStudentSelect from '../views/branch/history/StudyResultStudentSelect.vue'
import StudyResultSummary from '../views/branch/history/StudyResultSummary.vue'
import StudyResultDetail from '../views/branch/history/StudyResultDetail.vue'
import StudyResultLastMinuteCheck from '../views/branch/history/StudyResultLastMinuteCheck.vue'
import StudyResultResolve from '../views/branch/history/StudyResultResolve.vue'

/**
 * 教室側ページ群
 *   nameに接頭辞'Branch'を付ける
 */
const branchRoutes: Array<RouteConfig> = [
  {
    path: '/branch/login',
    name: 'BranchLogin',
    component: Login,
  },
  {
    path: '/branch/qr-login',
    name: 'BranchQrLogin',
    component: QrLogin,
  },
  {
    path: '/branch/study-management',
    name: 'BranchStudyManagement',
    component: StudyManagement,
  },
  {
    path: '/branch/study-management-candidate/:studyId',
    name: 'BranchStudyManagementCandidate',
    component: StudyManagementCandidate,
  },
  {
    path: '/branch/student-management',
    name: 'BranchStudentManagement',
    component: StudentManagement,
  },
  {
    path: '/branch/history/study-result-management',
    name: 'BranchHistoryStudyResultManagement',
    component: StudyResultManagement,
  },
  {
    path: '/branch/history/study-result-student-select/:studyId',
    name: 'BranchHistoryStudyResultStudentSelect',
    component: StudyResultStudentSelect,
  },
  {
    path: '/branch/history/study-result-summary/:studyId/:studentId',
    name: 'BranchHistoryStudyResultSummary',
    component: StudyResultSummary,
  },
  {
    path: '/branch/history/study-result-detail/:studyId/:studentId/:paperTestId',
    name: 'BranchHistoryStudyResultDetail',
    component: StudyResultDetail,
  },
  {
    path: '/branch/history/study-result-last-minute-check/:studyId/:studentId/:sUnitId',
    name: 'BranchHistoryStudyResultLastMinuteCheck',
    component: StudyResultLastMinuteCheck,
  },
  {
    path: '/branch/history/study-result-resolve/:studyId/:studentId/:sUnitId',
    name: 'BranchHistoryStudyResultResolve',
    component: StudyResultResolve,
  },
]

export default branchRoutes
